import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { CustomButton } from '../../custom-forms';

export interface RequeryDialogProps {
  open: boolean;
  onConfirm: (shouldRequery: boolean) => Promise<void>;
  onClose: () => void;
  title?: string;
  message?: string;
  yesLabel: string;
  noLabel: string;
}

const RequeryDialog: React.FC<RequeryDialogProps> = ({
  open,
  onConfirm,
  onClose,
  title = 'Confirmare ștergere piesă',
  message = 'Doriți să reinterogați piesa la un alt furnizor?',
  yesLabel,
  noLabel
}) => {
  const [loadingYes, setLoadingYes] = React.useState(false);
  const [loadingNo, setLoadingNo] = React.useState(false);

  const loading = loadingYes || loadingNo;

  const handleConfirm = async (shouldRequery: boolean) => {
    if (shouldRequery) setLoadingYes(true);
    else setLoadingNo(true);
    try {
      await onConfirm(shouldRequery);
    } finally {
      setLoadingYes(false);
      setLoadingNo(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <HelpOutlineIcon color="primary" />
          <span style={{ fontWeight: 600, fontSize: 16 }}>{title}</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)', marginBottom: 0 }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '8px 16px 16px' }}>
        <CustomButton
          variant="outlined"
          disabled={loading}
          isLoading={loadingNo}
          onClick={() => handleConfirm(false)}
        >
          {noLabel}
        </CustomButton>
        <CustomButton
          disabled={loading}
          isLoading={loadingYes}
          onClick={() => handleConfirm(true)}
        >
          {yesLabel}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default RequeryDialog;
